<div class="company-terms-view">
  <h2>Terms & Conditions</h2>
  <h3 *ngIf="companyName">{{ companyName }}</h3>
  <div [innerHTML]="termsContent"></div>
</div>